import { useState, useEffect } from "react";
import { formatDate } from "../../../uteis/dateUtils";
// --------------------- Import Services ---------------------
import { buscarEtiquetasService } from "../../../services/buscarEtiquetasService";

export const useBuscarEtiquetas = () => {
  const [etiquetas, setEtiquetas] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchLeads = async () => {
      setIsLoading(true);
      const data = await buscarEtiquetasService();

      const arrayData = data.map((data: any) => {
        return {
          key: data.id,
          nome: data.nome,
          descricao: data.descricao,
          cor: data.cor,
          
          createAt: formatDate(data.createdAt),
        };
      });

      setEtiquetas(arrayData);
      setIsLoading(false);
    };

    fetchLeads();
  }, []);
  // Retorna as variáveis de estado para o componente que utiliza este hook
  return { etiquetas, isLoading };
};
